<template>
  <div>
    <v-layout row wrap>
      <v-flex md8>
        <h1>Additional Bill</h1>
      </v-flex>
      <v-flex md2 class="text-lg-right">
        <el-button type="success" @click="submit" :disabled="this.basic_list.length === 0">
          <!-- <el-button type="success" @click="submit" :disabled="!valid" v-if='this.filteredCharges !== undefined'> -->
          Submit
        </el-button>
        <!-- <el-button  type="success" @click="GenerateBillCanvas" :disabled='this.basic_list.length === 0'>
        Bill
        </el-button>-->
      </v-flex>
    </v-layout>
    <v-form
      id="printMe"
      @submit.native.prevent="submitStop()"
      v-model="valid"
      ref="form"
      lazy-validation
    >
      <v-layout row wrap>
        <li v-for="(item, index) in this.basic_list" class="listOfCharges">
          <button @click.prevent="removeCharges(item)">
            <v-icon light>close</v-icon>
          </button>
          <input type="text" name v-model="item.name" id="detail" disabled>
          <input type="text" name id="qty" v-model="item.amount" @focus="inputFocus">
          <el-input v-model="item.quantity" size="medium" id="charge" @focus="inputFocus">
            <template slot="prepend">X</template>
          </el-input>
          <el-input :value="item.quantity*item.amount" size="medium" disabled>
            <template slot="prepend">₹</template>
          </el-input>
        </li>
      </v-layout>
      <v-layout row wrap v-if="this.basic_list.length > 0">
        <v-flex md8 class="text-lg-right">Total</v-flex>
        <v-flex md2 class="text-lg-right" v-if="this.basic_list.length > 0">{{this.billingTotals}}</v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md8 class="text-lg-right" v-if="this.basic_list.length > 0">Due</v-flex>
        <v-flex md2 class="text-lg-right" v-if="this.basic_list.length > 0">{{this.due}}</v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md8 class="text-lg-right" v-if="this.basic_list.length > 0">Excess</v-flex>
        <v-flex md2 class="text-lg-right" v-if="this.basic_list.length > 0">{{this.excess}}</v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md8 class="text-lg-right" v-if="this.basic_list.length > 0">Discount</v-flex>
        <v-flex md2 class="text-lg-right" v-if="this.basic_list.length > 0">
          <el-input v-model="discount" size="mini" class="discountInput" @focus="inputFocus"></el-input>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-items-center>
        <v-flex md8 class="text-lg-right" v-if="this.basic_list.length > 0">Amount to be paid</v-flex>
        <v-flex md2 class="text-lg-right" v-if="this.basic_list.length > 0">
          <h1>{{totalTotal}}</h1>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md8 class="text-lg-right" v-if="this.basic_list.length > 0">Total Amount paid</v-flex>
        <v-flex md2 class="text-lg-right" v-if="this.basic_list.length > 0">
          <el-input v-model="amountPaid" size="mini" class="discountInput" @focus="inputFocus"></el-input>
        </v-flex>
      </v-layout>
    </v-form>
    <v-select
      class="autocompleteSelect"
      v-bind:items="this.charges_list"
      v-model="a1"
      label="Select"
      return-object
      item-text="name"
      item-value="amount"
      :hint="`${a1.amount}`"
      persistent-hint
      autocomplete
    ></v-select>
    <!-- add -->
    <v-btn @click="addNewCharge">Add</v-btn>
  </div>
</template>

<script>
import Vue from "vue";
import { api } from "../api.js";
import { mapState } from "vuex";
import { axios, get, post } from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import _ from "lodash";
export default {
  name: "additionalBill",
  data() {
    return {
      billList: "",
      charges: "",
      valid: true,
      a1: {
        name: "",
        amount: ""
      },
      basic_list: [],
      charges: this.charges,
      charges_list: this.charges_list,
      itemTotal: "",
      discount: 0,
      due: this.due,
      amountPaid: 0,
      excess: this.excess
    };
  },
  computed: {
    appId: function() {
      if (this.$route.params.appId !== null) {
        return this.$route.params.appId;
      }
    },
    ptId: function() {
      if (this.$route.params.ptId !== null) {
        return this.$route.params.ptId;
      }
    },
    billingTotals: function() {
      let arr = this.basic_list;
      let sumOfitemTotals = 0;
      for (const i in arr) {
        sumOfitemTotals += arr[i].amount * arr[i].quantity;
      }
      return sumOfitemTotals;
    },
    totalTotal: function() {
      const masterTotal =
        this.billingTotals + this.due - this.discount - this.excess;
      // return this.billingTotals
      return masterTotal;
    }
  },
  mounted() {
    this.getBills();
    this.getCharges();
  },
  methods: {
    getBills() {
      get(api + `/billings?person_id=${this.ptId}&is_today=true`).then(res => {
        console.log(res);
        this.billList = res.data.bill_list;
      });
    },
    inputFocus() {
      $("#printMe input").on("keydown", e => {
        if (e.keyCode === 13) {
          e.preventDefault();
        }
      });
    },
    getCharges() {
      get(api + `/clinic_charges?person_id=${this.ptId}`).then(res => {
        this.charges = res.data.charge_list;
        this.charges_list = res.data.charge_list;
        this.due = res.data.due;
        this.excess = res.data.excess;
      });
    },
    addNewCharge() {
      this.basic_list.push({
        id: this.a1.id,
        name: this.a1.name,
        amount: this.a1.amount,
        quantity: 1
      });
    },
    removeCharges(item) {
      var index = this.basic_list.indexOf(item);
      if (index !== -1) {
        this.basic_list.splice(index, 1);
      }
    },
    GenerateBillCanvas() {
      html2canvas(document.getElementById("printMe")).then(canvas => {
        const imgData = canvas.toDataURL("image/png");
        document.body.appendChild(canvas);
        const pdf = new jsPDF();
        pdf.addImage(canvas, "JPEG", 0, 0);
        // pdf.output('dataurlnewwindow');
        // pdf.save("download.pdf");
      });
    },
    submitStop() {
      console.log("Stop");
    },
    submit() {
      var intAppId = parseInt(this.appId);
      let billingPayload = {
        appointment_id: intAppId,
        master_bill: 0,
        paid: this.amountPaid,
        discount: this.discount,
        fee: []
      };
      this.basic_list.forEach(function(item) {
        billingPayload.fee.push({
          id: item.id,
          amount: item.amount,
          quantity: item.quantity
        });
      });
      console.log(billingPayload);
      // POST
      post(api + `/billings`, billingPayload).then(res => {
        console.log(res.data);
        if ((res.data.message = "Bill successfully posted")) {
          let clinic_id = localStorage.getItem("clinic_id");
          let doctor_id = localStorage.getItem("doctor_id");
          this.$router.push("/dashboard/" + clinic_id + "/" + doctor_id);
          // this.$router.push("/dashboard");
        }
      });
    }
  }
};
</script>

<style lang="css" scoped>
#detail {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  margin: 10px;
  padding: 8px;
  /* width: 30%; */
  margin-left: 2rem;
}

#charge {
  border: 1px solid #d8d8d8;
  /* border-radius: 4px; */
  padding: 8px;
  /* width: 15%; */
  /* margin: 10px; */
}

#qty {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  margin: 10px;
  padding: 8px;
  /* width: 10%; */
}
.el-input {
  margin: auto;
  width: 150px;
}
.el-input.el-input-group--prepend.is-disabled {
  margin-left: 1rem;
}
.discountInput {
  width: 100px;
}
.discountInput .el-input__inner {
  text-align: right;
  width: 150px;
}
.align-items-center {
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/additionalBill.vue